
import React, { useEffect, useState } from "react";
import "./ProjectHead.css";
import Navbar from "./NavBar";

const PropertyCard = ({ item }) => {
  const [index, setIndex] = React.useState(0);
  const [docSizes, setDocSizes] = React.useState([]);

  const images = item.property_images || [];
  const documents = item.property_documents || [];

  // get file size
  React.useEffect(() => {
    const fetchSizes = async () => {
      const sizes = await Promise.all(
        documents.map(async (url) => {
          try {
            const res = await fetch(url, { method: "HEAD" });
            const size = res.headers.get("content-length");
            return size
              ? (size / 1024).toFixed(1) + " KB"
              : "PDF";
          } catch {
            return "PDF";
          }
        })
      );
      setDocSizes(sizes);
    };

    if (documents.length) fetchSizes();
  }, [documents]);

  const nextImage = () =>
    setIndex((prev) => (prev + 1) % images.length);

  const prevImage = () =>
    setIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );

  return (
    <div className="property-card">
      {/* IMAGE CAROUSEL */}
      <div className="carousel">
        {images.length > 0 && (
          <img src={images[index]} alt={item.title} />
        )}

        {images.length > 1 && (
          <>
            <button className="prev-btn" onClick={prevImage}>‹</button>
            <button className="next-btn" onClick={nextImage}>›</button>
          </>
        )}
      </div>

      {/* PROPERTY INFO */}
      <div className="property-info">
        <h3>{item.title}</h3>
        <p>{item.location}</p>
        <span>₹ {item.price}</span>
        <span>{item.description}</span>
      </div>

      {/* DOCUMENTS */}
      {documents.length > 0 && (
        <div className="doc-container">
          {documents.map((doc, i) => (
            <a
              key={i}
              href={doc}
              target="_blank"
              rel="noopener noreferrer"
              className="doc-item"
            >
              📄 <span>{docSizes[i] || "PDF"}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};


const Properties = () => {


    
        const [properties, setProperties] = useState([]);
              const [agents, setAgents] = useState([]);
      


        useEffect(() => {
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;

  fetch("https://api.propertygalleria.in/master/api/get/owner/properties")
    .then(res => res.json())
    .then(data => {
      if (data.success && userId) {
        const filtered = data.data.filter(
          item => item.handling_head_id === userId
        );
        // console.log('this is filtered',filtered)
        setProperties(filtered);
      }
    });
}, []);


        useEffect(() => {
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;
console.log('this i suserId',userId)

  fetch("https://api.propertygalleria.in/master/api/users/agentss")
    .then(res => res.json())
    .then(data => {
      if (userId) {
        console.log('this is typeof',typeof userId); // string or number?
console.log('this is type of from api',typeof data[0].reports_to_head_id); // number

        const filtered = data.filter(
          item => item.reports_to_head_id === userId
        );
        console.log('this is filtered',filtered)
        setAgents(filtered);
      }
    });
}, []);

console.log('this is agents',agents)
    

    return (
        <>
        <Navbar/>
        <div className="project-head-container" style={{marginTop:'5%'}}>

            {/* 🔥 HERO SECTION */}
            {/* <div className="hero-section">
                <h1>Project Head Dashboard</h1>
                <p>Manage properties & agents</p>
            </div> */}

            {/* 🏢 PROPERTIES */}
            <section className="section ">
                <h2>Assigned Properties</h2>

                <div className="property-grid">
                  
                    <div className="property-grid">
  {properties.map((item) => (
    <PropertyCard key={item.id} item={item} />
  ))}
</div>

                </div>
            </section>

            {/* 👥 AGENTS */}
            {/* <section className="section">
                <h2>Agents ({agents.length})</h2>

                <div className="agent-grid">
                    {agents.map((agent) => (
                        <div className="agent-card" key={agent.id}>
                            <h4>{agent.full_name}</h4>
                            <p>📞 {agent.mobile_number}</p>
                            <p>📍Exp: {agent.experience_years}</p>
                        </div>
                    ))}
                </div>
            </section> */}

        </div>
        </>
    );
};

export default Properties;
